<template>
   <div class="main">
   <div class="control-section">
    <div class="ptitle"> Panel administracyjny główny </div>
    <!--  DashboardLayout element declaration -->
    <ejs-dashboardlayout id='dashboard_default' :cellSpacing='cellSpacing' :columns="4" :allowResizing="false" :allowDragging="false">
      <e-panels>
	<e-panel :row="1" :col="1" content="<div class='content'>PANEL KONFIGURACYJNY<br/></div>"></e-panel>
	<e-panel :row="1" :col="2" content="<div class='content'>PANEL ZARZĄDZANIA UŻYTKOWNIKAMI<br/></div>"></e-panel>
      </e-panels>
    </ejs-dashboardlayout>
    <!-- end of dashboardlayout element -->
    <fullscreen class="fullscreen-wrapper" v-model="fullscreen">
    </fullscreen>
    <div class="fs-box">
    <button class="fullscrbtn" type="button" @click="toggleApi" >{{btnTitle}}</button>
    </div>
   </div>
    <div class="logout">
    	<button id="logout" @click="logoutclick">Wyloguj</button>
    </div>
   </div>
</template>


<script>
import { DashboardLayoutComponent, PanelDirective, PanelsDirective } from "@syncfusion/ej2-vue-layouts";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-layouts/styles/material.css";
import axios from "axios";
import Storage from "./Storage.vue";
import * as CONFIG from "./config.js";
axios.defaults.withCredentials = false;

export default {
  name: "app2",
  components: { 
	"ejs-dashboardlayout": DashboardLayoutComponent,
        "e-panels":PanelsDirective,
        "e-panel":PanelDirective,
  },
  data:() => ({
    fullscreen: false,
		btnTitle: 'Pełny ekran',
    urlUsers: '/agent/GALEK.Magazyn/AktualizujUzytkownikowPanelu',
    url: CONFIG.API_DOMAIN + 'users',
    users: [],
    usersWorkers: [],
    aspectRatio: 100/85,
    cellSpacing: [10,10],

  }),
  watch:{
    fullscreen(){
      if(this.fullscreen === false){
        this.btnTitle = 'Pełny ekran'
      }
      else{
        this.btnTitle = 'Pełny ekran'
      }
    }
  },
  methods: {
    toggle () {
      this.fullscreen = !this.fullscreen
      console.log(this.btnTitle)
    },
    toggleApi () {
      this.$fullscreen.toggle()
      this.fullscreen = !this.fullscreen
      console.log(this.btnTitle)
    },
    logoutclick() {
      Storage.cleanJWT().then(resp => {
        this.$router.push({ path: "/" });
      });
  	},
    panel1click() {
      //alert("panel1: " + this.myGlobalVariable);
      this.$router.push({ path: "/paneladmin/panelkonfiguracyjny" });
    },
    panel2click() {
      //alert("panel2: " + this.myRouter);
      this.$router.push({ path: "/paneladmin/uzytkownicy" });
    },
    getData() {
      return axios
          .get(this.url, {
          headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "Accept": "application/json",
                  "Authorization": "Bearer " +  this.jwt,
          }
          })
          .then(response => {
                  return response.data;
          })
          .catch(e => {
                  alert("ERROR" + e);
          });
    },
    updateUsers(requestBody) {
      return axios
        .post(CONFIG.API_URL + this.urlUsers, {uzytkownicy:requestBody}, {
        headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json",
                "Authorization": "Bearer " +  this.jwt,
        }
        })
        .then(response => {
                return response.data;
        })
        .catch(e => {
                alert("ERROR" + e);
        });
    },
    setBody(){
      var tempusers = '';
      this.users.forEach((value) => {
        tempusers = tempusers + value.id + ';'
      })
      this.requestBody = {'uzytkownicy': tempusers}
      return this.requestBody
    }
  },
  mounted() {
    var that = this;
    Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
            that.jwt = resp.access_token;
            that.getData().then(data => {
                that.users = data
                var temp = that.setBody();
                that.updateUsers(temp.uzytkownicy).then(data => {
                  that.usersWorkers = data
                })  
            });


        });
    document.querySelector("#layout_0").addEventListener('click', function() { that.panel1click(); } );
	  document.querySelector("#layout_1").addEventListener('click', function() { that.panel2click(); } );
  }
}


</script>

<style> 
.ptitle {
  margin-bottom:20px;
  margin-left: 260px;
  text-align: left;
}

/* DashboardLayout element styles  */
#dashboard_default .e-panel .e-panel-container .content {
  vertical-align: middle;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  line-height: 50px;
  margin-top: 30px;
}

#dashboard_default .e-panel {
  transition:none !important;
}

.logout {
	width: 200px;
	height: 50px;
  position:fixed;
  bottom: 10px;
	text-align: left;
	background-color: #FFFFFF;
	float: left;
}
#logout {
	width: 200px;
	height: 50px;
	position:relative;
	background-color: #FFFFFF;
}
.fullscrbtn{
  	color: #FFFFFF;
    background-color: royalblue;
    width: 200px;
    height: 40px;
    float: center;
}
@media screen and (max-width: 1024px){
.fs-box{
    position:fixed;
    bottom: 60px;
    width: 100%;
}
}
@media screen and (min-width: 1025px){
.fs-box{
    display: none;
    position:fixed;
    bottom: 60px;
    width: 100%;
}
}
.fullscreen-wrapper {
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  }
</style> 



// WEBPACK FOOTER //
// src/components/PanelAdminContent.vue